import { useState } from "react";
import { Card, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLeague } from "../../hooks/useLeague";
import WizardProgress from "../WizardProgress";
import SeasonDetailsStep from "./SeasonDetailsStep";
import TeamsStep from "./TeamsStep";

function SeasonSetupWizard() {
  const [currentStep, setCurrentStep] = useState(0);
  const [seasonData, setSeasonData] = useState<any>(null);
  const auth = useAuth();
  const { currentLeague } = useLeague();
  const navigate = useNavigate();

  const steps = ["Season Details", "Add Teams", "Complete"];

  const handleSeasonCreated = (season: any) => {
    setSeasonData(season);
    setCurrentStep(1);
  };

  const handleTeamsComplete = () => {
    setCurrentStep(2);
  };

  const handleFinish = () => {
    navigate("/admin", { replace: true });
  };

  if (!currentLeague) {
    return (
      <Card>
        <Card.Body>
          <Alert variant="warning">
            No league selected. Please create a league first.
          </Alert>
          <Button variant="primary" onClick={() => navigate("/setup/league")}>
            Create League
          </Button>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Body>
        <WizardProgress steps={steps} currentStep={currentStep} />

        {currentStep === 0 && (
          <SeasonDetailsStep
            onNext={handleSeasonCreated}
            leagueId={currentLeague.id}
            token={auth.token}
            leagueAbbr={currentLeague.abbr}
          />
        )}

        {currentStep === 1 && seasonData && (
          <TeamsStep
            onNext={handleTeamsComplete}
            seasonId={seasonData.id}
            leagueId={currentLeague.id}
            token={auth.token}
            leagueAbbr={currentLeague.abbr}
          />
        )}

        {currentStep === 2 && (
          <div className="text-center">
            <h4 className="mb-3">Setup Complete!</h4>
            <p className="text-muted mb-4">
              Your league and season have been created successfully. You can now
              start managing your league.
            </p>
            <div className="d-grid">
              <Button variant="primary" size="lg" onClick={handleFinish}>
                Go to Admin Dashboard
              </Button>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default SeasonSetupWizard;
